<template>
  <el-card
    class="h-full bg-transparent !shadow-none"
    :body-style="{
      padding: '0px',
      height: '100%',
      'padding-right': '10px',
      overflow: 'auto',
      'background-color': 'transparent',
    }"
  >
    <el-card
      :body-style="{
        padding: '10px',
      }"
    >
      <div class="flex justify-between">
        <!-- <div>
          <el-select
            size="small"
            placeholder="请选择标准库"
            v-model="standardId"
            filterable
            :loading="standardLoading"
            @change="swtichPeriod"
          >
            <el-option
              v-for="item in standardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div> -->
        <div class="pr-40px flex justify-center items-center">
          <span>统计周期：</span>
          <el-radio-group v-model="statisticalPeriod" @change="swtichPeriod">
            <el-radio
              v-for="(item, index) in periodList"
              :key="index"
              :label="item.label"
              class="mr-10px"
            ></el-radio>
          </el-radio-group>
        </div>
      </div>
    </el-card>

    <el-row class="mt-10px" :gutter="20">
      <el-col :span="6" v-for="(item, index) in dataBoxList" :key="index">
        <el-card>
          <div class="h-100px flex justify-between items-center">
            <div class="flex-grow-3 text-center flex justify-center items-center">
              <div :class="item.className" class="w-45px h-45px bg-no-repeat bg-center"></div>
            </div>
            <div class="flex-grow-2">
              <p class="text-18px text-hex-303133">{{ item.title }}</p>
              <div class="text-30px pt-20px flex justify-start">
                <p>{{ item.value }}</p>
                <p class="text-14px text-hex-666 flex flex-col items-end ml-65px justify-end">
                  {{ item.unit }}
                </p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="mt-10px" :gutter="20">
      <el-col :span="8">
        <el-card>
          <div class="font-bold box-title">任务状态占比分析</div>
          <v-chart
            :options="allStatusOption"
            class="h-200px w-full"
            v-loading="statusOptionLoading"
          ></v-chart>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div class="font-bold box-title">数据表采集状态占比分析</div>
          <v-chart
            :options="entityOption"
            class="h-200px w-full"
            v-loading="statusOptionLoading"
          ></v-chart>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div class="font-bold box-title">采集任务状态占比分析</div>
          <v-chart
            :options="taskOption"
            class="h-200px w-full"
            v-loading="statusOptionLoading"
          ></v-chart>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-10px">
      <el-card>
        <div class="font-bold box-title">各时段采集任务分布图</div>
        <div class="flex">
          <div class="flex flex-col justify-around items-center mt-16px">
            <el-card
              :body-style="{
                width: '280px',
                padding: '10px',
                height: '100px',
                'padding-right': '10px',
                'background-color': 'transparent',
              }"
            >
              <div class="flex justify-around items-center h-full">
                <div class="collect_count_box w-30px h-full bg-no-repeat"></div>
                <div class="flex flex-col justify-around items-start h-full">
                  <span class="text-14px font-bold">采集成功总数(个)</span>
                  <span class="text-30px text-[#000]">{{ collectionSuccessTotal }}</span>
                </div>
                <div class="flex flex-col justify-end items-start h-full text-center">
                  <p class="text-12px text-hex-666 w-full flex justify-center items-center">
                    20.5%
                    <span
                      class="down-icon-box ml-5px inline-block w-15px h-20px bg-no-repeat bg-center"
                    ></span>
                  </p>
                  <p class="mr-10px text-[#c2c2c2] text-12px w-full mt-10px">
                    自从上周以来
                  </p>
                </div>
              </div>
            </el-card>
            <el-card
              :body-style="{
                width: '280px',
                padding: '10px',
                height: '100px',
                'padding-right': '10px',
                'background-color': 'transparent',
              }"
            >
              <div class="flex justify-around items-center h-full">
                <div class="collect_faliure_box w-30px h-full bg-no-repeat"></div>
                <div class="flex flex-col justify-around items-start h-full">
                  <span class="text-14px font-bold">采集失败总数(个)</span>
                  <span class="text-30px text-[#000]">{{ collectionFailTotal }}</span>
                </div>
                <div class="flex flex-col justify-end items-start h-full text-center">
                  <p class="text-12px text-hex-666 w-full flex justify-center items-center">
                    20.5%
                    <span
                      class="up-icon-box ml-5px inline-block w-15px h-20px bg-no-repeat bg-center"
                    ></span>
                  </p>
                  <p class="mr-10px text-[#c2c2c2] text-12px w-full mt-10px">
                    自从上周以来
                  </p>
                </div>
              </div>
            </el-card>
          </div>
          <v-chart class="!w-9/10 !h-250px" :options="barOption"></v-chart>
        </div>
      </el-card>
    </el-row>
    <el-row class="mt-10px" :gutter="20">
      <el-col :span="12">
        <el-card class="pb-16px">
          <div class="font-bold box-title">
            <span>实体对象采集排行</span>
            <!-- <span class="font-normal text-12px text-blue-500 ml-5px cursor-pointer">查看详情</span> -->
          </div>
          <el-table
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            class="mt-10px"
            :data="entityRankList"
            border
            height="440px"
            ref="entityRankRef"
          >
            <el-table-column type="index" width="75" sortable label="序号"></el-table-column>
            <el-table-column
              prop="batchCode"
              label="批次号"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="runTime"
              label="提交日期"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="submitUserName"
              label="提交人"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="entityName"
              label="实体对象"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="count" label="数据量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="taskStatusStr" label="流程状态" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            class="float-right mt-20px"
            background
            :current-page.sync="entityTablePage.pageNo"
            :page-size.sync="entityTablePage.pageSize"
            layout="total, sizes ,prev, pager, next"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="entityTablePage.totalCount"
          ></el-pagination> -->
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="pb-16px">
          <div class="font-bold box-title">
            <span>采集任务执行排行</span>
            <!-- <span class="font-normal text-12px text-blue-500 ml-5px cursor-pointer">查看详情</span> -->
          </div>
          <el-table
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            class="mt-10px"
            :data="taskRankList"
            border
            height="440px"
            ref="entityTableRef"
          >
            <el-table-column type="index" width="75" sortable label="序号"></el-table-column>
            <el-table-column
              prop="batchCode"
              label="任务批号"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="runTime" label="数据源" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="submitUserName"
              label="任务名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="entityName"
              label="任务类型"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="count"
              label="任务执行次数"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="taskStatusStr" label="任务状态" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            class="float-right mt-20px"
            background
            :current-page.sync="entityTablePage.pageNo"
            :page-size.sync="entityTablePage.pageSize"
            layout="total, sizes ,prev, pager, next"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="entityTablePage.totalCount"
          ></el-pagination> -->
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import DataMonitorTaskService from '@/services/dataMonitorTaskService'
import dayjs from 'dayjs'

export default {
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  props: {
    standardId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // standardId: '', // 标准库id
      standardList: [], // 标准库列表
      standardLoading: false, // 标准库列表loading
      statisticalPeriod: '今日', // 统计周期
      periodList: [
        {
          label: '今日',
          value: 0,
        },
        {
          label: '昨日',
          value: 0,
        },
        {
          label: '本周',
          value: 1,
        },
        {
          label: '本月',
          value: 2,
        },
        {
          label: '本年',
          value: 3,
        },
      ], // 统计周期列表
      taskTotalCount: '', // 实体对象采集任务总数
      taskTotalLoading: false, // 实体对象采集任务总数loading
      taskDataTotalCount: '', // 实体对象采集数据总数
      taskDataTotalLoading: false, // 实体对象采集数据总数loading
      pieOption: {
        color: ['#3aa0ff', '#35cbca', '#00a870', '#ed7b2f', '#f2637b', '#975fe4'],
        title: {},
        tooltip: {
          trigger: 'item',
        },
        legend: {},
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['55%', '75%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 3,
            },
            data: [],
          },
          // 给图表外层加一个圈圈
          {
            name: '',
            type: 'pie',
            radius: ['80%', '81%'],
            center: ['30%', '50%'],
            borderColor: '#999',
            shadowColor: '#999',
            data: [
              {
                value: 1,
                itemStyle: { color: '#ccc' },
              },
            ],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            selectedMode: null,
            hoverAnimation: false,
            legendHoverLink: false,
            tooltip: {
              show: false, // 取消悬浮时显示数据
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 4,
              emphasis: {
                disabled: true,
              },
              animation: false,
              silent: true,
              itemStyle: {
                color: '#999',
              },
              data: [
                {
                  x: '14%',
                  y: '50%',
                },
                {
                  x: '46%',
                  y: '50%',
                },
              ],
            },
          },
        ],
      },
      allStatusOption: {
        color: ['#3aa0ff', '#35cbca', '#00a870', '#ed7b2f', '#f2637b', '#975fe4'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: 'center',
          right: '80',
          icon: 'rect',
          orient: 'vertical',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            padding: [2, 0, 0, 10],
            rich: {
              name: {
                fontSize: 12,
                padding: [0, 10, 0, 0],
                color: '#666',
              },
              percent: {
                fontSize: 12,
                padding: [0, 10, 0, 0],
                color: '#000',
              },
              unit: {
                fontSize: 12,
                color: '#000',
              },
            },
          },
          formatter: (name) => {
            const value = _.find(this.allStatusOption.series[0].data, (item) => {
              return item.name === name
            })?.value
            const arr = [
              `{name|${name}}`,
              `{percent|${value ? `${((value / 120) * 100).toFixed(2)}%` : ''}}`,
              `{unit|${value ?? ''}}`,
            ]
            return arr.join(' ')
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['55%', '75%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 3,
            },
            data: [],
          },
          // 给图表外层加一个圈圈
          {
            name: '',
            type: 'pie',
            radius: ['80%', '81%'],
            center: ['30%', '50%'],
            borderColor: '#999',
            shadowColor: '#999',
            data: [
              {
                value: 1,
                itemStyle: { color: '#ccc' },
              },
            ],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            selectedMode: null,
            hoverAnimation: false,
            legendHoverLink: false,
            tooltip: {
              show: false, // 取消悬浮时显示数据
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 4,
              emphasis: {
                disabled: true,
              },
              animation: false,
              silent: true,
              itemStyle: {
                color: '#999',
              },
              data: [
                {
                  x: '14%',
                  y: '50%',
                },
                {
                  x: '46%',
                  y: '50%',
                },
              ],
            },
          },
        ],
      }, // 任务状态占比分析环形图配置
      entityOption: {}, // 实体对象采集状态占比分析环形图配置
      taskOption: {}, // 采集任务状态占比分析环形图配置
      statusOptionLoading: false, // 获取占比分析数据loading
      statusList: [
        {
          label: '待审批',
          value: 1,
        },
        {
          label: '审批中',
          value: 2,
        },
        {
          label: '审批通过',
          value: 4,
        },
        {
          label: '审批拒绝',
          value: 5,
        },
      ], // 状态列表
      barOption: {
        color: ['3ae474', 'ffb525'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true,
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                fontSize: 12,
                color: '#666',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
            axisTick: {
              alignWithLabel: true,
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                fontSize: 12,
                color: '#666',
              },
            },
          },
        ],
        series: [
          {
            name: '正常',
            type: 'bar',
            // stack: 'total',
            emphasis: {
              focus: 'series',
            },
            color: '#3ae474',
            barWidth: 10,
            data: [],
          },
          {
            name: '报警',
            type: 'bar',
            // stack: 'total',
            emphasis: {
              focus: 'series',
            },
            color: '#ffb525',
            barWidth: 10,
            data: [],
          },
        ],
      },
      collectionSuccessTotal: 0, // 采集成功总数
      collectionFailTotal: 0, // 采集失败总数
      entityRankList: [], // 实体对象采集排行列表
      entityRankLoading: false, // 实体对象采集排行列表loading
      taskRankList: [], // 采集任务执行排行列表
      entityTablePage: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      }, // 实体对象采集排行列表分页
      dataBoxList: [
        {
          className: 'data-source-box',
          title: '数据源总数',
          value: '1'.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          unit: '个',
        },
        {
          className: 'data-collect-box',
          title: '数据采集任务总数',
          value: '1888'.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          unit: '个',
        },
        {
          className: 'data-count-box',
          title: '数据采集数据总量',
          value: 0,
          unit: 'GB',
        },
        {
          className: 'data-number-box',
          title: '数据采集数据总数',
          value: 0,
          unit: '万条',
        },
      ], // 数据渲染列表
    }
  },
  methods: {
    /**
     * @description 获取标准库列表
     */
    async getStandardList() {
      this.standardLoading = true
      const res = await StandardManagementService.getList()
      this.standardLoading = false
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardId = this.standardList[0]?.id
      }
    },

    /**
     * @description 根据周期获取时间范围
     * @returns {Object} 包含时间段开始时间和结束时间
     */
    getTimeQuantum() {
      let startTime = ''
      let endTime = ''
      const date = new Date()

      switch (this.statisticalPeriod) {
        case '今日':
          startTime = new Date().setHours(0, 0, 0, 0)
          endTime = new Date().setHours(23, 59, 59, 999)
          break
        case '昨日':
          startTime = new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)
          endTime = new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999)
          break
        case '本周':
          const current = new Date() // current是本周的第几天
          let nowDayOfWeek = current.getDay()
          if (nowDayOfWeek === 0) nowDayOfWeek = 7
          const dayNum = 1 * 24 * 60 * 60 * 1000
          startTime = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum).setHours(0, 0, 0, 0) // 获取本周星期一的时间，星期一作为一周的第一天
          endTime = new Date(new Date(startTime).valueOf() + 6 * dayNum).setHours(23, 59, 59, 999) // 获取本周星期天的时间，星期天作为一周的最后一天
          break
        case '本月':
          startTime = new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)
          const nextMonthFirstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1)
          endTime = new Date(nextMonthFirstDay - 24 * 60 * 60 * 1000).setHours(23, 59, 59, 999)
          break
        case '本年':
          date.setDate(1)
          date.setMonth(0)
          date.setHours(0, 0, 0, 0)
          startTime = new Date(date)
          date.setFullYear(date.getFullYear() + 1) // 设置到明年
          date.setMonth(0) // 明年的0月，也就是对应到1月
          date.setDate(0) // 明年的0日
          endTime = new Date(new Date(date).getTime() - 24 * 60 * 60 * 1000).setHours(
            23,
            59,
            59,
            999
          )
          break
        default:
          break
      }

      return {
        startTime: dayjs(startTime).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(endTime).format('YYYY-MM-DD HH:mm:ss'),
      }
    },

    /**
     * @description 获取实体对象采集任务总数
     */
    async getTaskTotalCount() {
      const { startTime, endTime } = this.getTimeQuantum()
      this.taskTotalLoading = true
      const res = await DataMonitorTaskService.getTaskTotalCount({
        startTime,
        endTime,
        standardId: this.standardId,
      })
      this.taskTotalLoading = false
      if (res && res.code === 0) {
        this.taskTotalCount = res.data
        this.dataBoxList[1].value = res.data
      }
    },

    /**
     * @description 获取实体对象采集任务数据总数
     */
    async getTaskDataTotalCount() {
      const { startTime, endTime } = this.getTimeQuantum()
      this.taskDataTotalLoading = true
      const res = await DataMonitorTaskService.getTaskDataTotalCount({
        startTime,
        endTime,
        standardId: this.standardId,
      })
      this.taskDataTotalLoading = false
      if (res && res.code === 0) {
        this.taskDataTotalCount = res.data
        this.dataBoxList[3].value = (this.taskDataTotalCount / 1000).toFixed(4)
      }
    },

    /**
     * @description 获取任务状态占比分析、实体对象采集状态占比分析、采集任务状态占比分析
     */
    async getAllStatusAnalyse() {
      this.statusOptionLoading = true
      const [allStatusRes, entityRes, taskRes] = await Promise.all([
        this.getTaskStatus(),
        this.getTaskStatus(0),
        this.getTaskStatus(1),
      ])
      this.statusOptionLoading = false
      if (allStatusRes) {
        this.setStatusPieOption(allStatusRes, this.allStatusOption)
      }
      if (entityRes) {
        this.setStatusPieOption(entityRes, this.entityOption)
      }
      if (taskRes) {
        this.setStatusPieOption(taskRes, this.taskOption)
      }
    },

    /**
     * @description 设置状态饼状图数据及状态
     * @param {Array} dataList 数据
     * @param {Object} pieOption 要设置数据和状态的饼图对象
     */
    setStatusPieOption(dataList, pieOption) {
      if (!dataList.length) {
        pieOption.series[0].data = []
        return
      }
      const setDataList = []
      dataList.forEach((item) => {
        const statusItem = this.statusList.find((status) => {
          return status.value === item.taskStatus
        })
        if (statusItem) {
          setDataList.push({
            name: statusItem.label,
            value: item.count,
          })
        }
      })
      pieOption.series[0].data = [...setDataList]
      pieOption.legend = {
        top: 'center',
        right: '80',
        icon: 'rect',
        orient: 'vertical',
        itemHeight: 8,
        itemWidth: 8,
        textStyle: {
          padding: [2, 0, 0, 10],
          rich: {
            name: {
              fontSize: 12,
              padding: [0, 10, 0, 0],
              color: '#666',
            },
            percent: {
              fontSize: 12,
              padding: [0, 10, 0, 0],
              color: '#000',
            },
            unit: {
              fontSize: 12,
              color: '#000',
            },
          },
        },
        formatter: (name) => {
          const value = _.find(this.allStatusOption.series[0].data, (item) => {
            return item.name === name
          })?.value
          const arr = [
            `{name|${name}}`,
            `{percent|${value ? `${((value / 120) * 100).toFixed(2)}%` : ''}}`,
            `{unit|${value ?? ''}}`,
          ]
          return arr.join(' ')
        },
      }
    },

    /**
     * @description 获取采集任务状态统计
     * @param {Number} taskType 1.etl采集任务 0.实体对象采集
     */
    async getTaskStatus(taskType) {
      const { startTime, endTime } = this.getTimeQuantum()
      const payload = {
        startTime,
        endTime,
        standardId: this.standardId,
      }
      if (typeof taskType === 'number') {
        payload.taskType = taskType
      }
      const res = await DataMonitorTaskService.getTaskStatusTotal(payload)
      if (res && res.data && res.code === 0) {
        return res.data
        // this.taskDataTotalCount = res.data
      }
      return null
    },

    /**
     * @description 获取实体对象采集任务分布统计
     */
    async getTaskDistribution() {
      const { startTime, endTime } = this.getTimeQuantum()
      const termType = _.find(this.periodList, (item) => {
        return item.label === this.statisticalPeriod
      })?.value
      const res = await DataMonitorTaskService.getTaskDistribution({
        startTime,
        endTime,
        termType,
        standardId: this.standardId,
      })
      if (res && res.data && res.code === 0) {
        // this.taskDataTotalCount = res.data
        this.barOption.xAxis[0].data = _.map(res.data, 'time')
        this.barOption.series[0].data = _.map(res.data, 'successCount')
        this.barOption.series[1].data = _.map(res.data, 'failedCount')
      }
    },

    /**
     * @description 获取实体对象采集排行列表
     */
    async getEntityRankList() {
      const { startTime, endTime } = this.getTimeQuantum()
      this.entityRankLoading = true
      const res = await DataMonitorTaskService.getTaskRanking({
        startTime,
        endTime,
        standardId: this.standardId,
      })
      this.entityRankLoading = false
      if (res && res.data && res.code === 0) {
        this.entityRankList = res.data
        this.entityRankList.forEach((item) => {
          item.taskStatusStr = ''
          if (item.taskStatus) {
            const statusItem = _.find(this.statusList, (status) => {
              return status.value === item.taskStatus
            })
            if (statusItem) {
              item.taskStatusStr = statusItem.label
            }
          }
        })
      }
    },

    /**
     * @description 统计周期切换
     */
    swtichPeriod() {
      this.getTaskTotalCount()
      this.getTaskDataTotalCount()
      this.getAllStatusAnalyse()
      this.getTaskDistribution()
      this.getEntityRankList()
    },

    /**
     * @description 跳转到任务管理页面
     * @param {String} type 'entity':实体对象采集清单 'task':采集任务清单
     */
    goTaskManagementPage(type) {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/online-filling/task-management`,
        query: {
          type,
        },
      })
    },
  },
  async created() {
    this.allStatusOption = _.cloneDeep(this.pieOption)
    this.entityOption = _.cloneDeep(this.pieOption)
    this.taskOption = _.cloneDeep(this.pieOption)
    // await this.getStandardList()
    // this.swtichPeriod()
  },
  watch: {
    standardId: {
      handler(data) {
        if (data) {
          this.getTaskTotalCount()
          this.getTaskDataTotalCount()
          this.getAllStatusAnalyse()
          this.getTaskDistribution()
          this.getEntityRankList()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.\!shadow-none {
  --tw-shadow-color: 0, 0, 0 !important;
  --tw-shadow: none !important;
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
}
.flex-grow-2 {
  flex-grow: 2;
}
.flex-grow-3 {
  flex-grow: 3;
}
.box-title {
  font-size: 17px;
  height: 18px;
  line-height: 18px;
  padding-left: 10px;
  border-left: 1px solid blue;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.data-source-box,
.data-collect-box,
.data-count-box,
.data-number-box {
  background-size: 100% 100%;
}
.data-source-box {
  background-image: url('../../assets/images/data_source.png');
}
.data-collect-box {
  background-image: url('../../assets/images/data_collect.png');
}
.data-count-box {
  background-image: url('../../assets/images/data_all_count.png');
}
.data-number-box {
  background-image: url('../../assets/images/data_all_number.png');
}
.collect_count_box,
.collect_faliure_box {
  background-position: center top;
  background-size: 30px 30px;
}
.collect_count_box {
  background-image: url('../../assets/images/success_count.png');
}
.collect_faliure_box {
  background-image: url('../../assets/images/failure_count.png');
}
.down-icon-box,
.up-icon-box {
  background-size: 100% 100%;
}
.down-icon-box {
  background-image: url('../../assets/images/down_icon.png');
}
.up-icon-box {
  background-image: url('../../assets/images/up_icon.png');
}
label {
  margin-bottom: 0px !important;
}

</style>
